var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden)?_c('vue-recaptcha',_vm._g(_vm._b({ref:"vue_recaptcha",class:_vm.scopedClass,attrs:{"sitekey":_vm.sitekey,"loadRecaptchaScript":_vm.loadRecaptchaScript},on:{"verify":_vm.updateToken,"expired":_vm.clearToken}},'vue-recaptcha',_vm.rProps,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }